import React from 'react';

const FacilityTab = ({ roomDetails }) => {
  return (
    <div className="card w-100 h-100">
      <div className="card-body p-4">
        <h5 className="mb-4">Hotel Facilities</h5>
        <div className="row g-4">
          {roomDetails.airconditioner && (
            <div className="col-md-3 col-6">
              <div className="facility-item">
                <i className="fas fa-snowflake"></i>
                <span>Air Conditioning</span>
              </div>
            </div>
          )}
          {/* Add other facility items similarly */}
          {roomDetails.wifi && (
            <div className="col-md-3 col-6">
              <div className="facility-item">
                <i className="fas fa-wifi"></i>
                <span>Free WiFi</span>
              </div>
            </div>
          )}
          {/* Continue with other facilities */}
        </div>

        <h5 className="mb-4 mt-5">Safety & Security</h5>
        <div className="row g-4">
          {roomDetails.smokeDetector && (
            <div className="col-md-3 col-6">
              <div className="facility-item">
                <i className="fas fa-smoke-detector"></i>
                <span>Smoke Detector</span>
              </div>
            </div>
          )}
          {/* Add other safety items */}
        </div>

        <h5 className="mb-4 mt-5">Additional Services</h5>
        <div className="row g-4">
          {roomDetails.newsPaper && (
            <div className="col-md-3 col-6">
              <div className="facility-item">
                <i className="fas fa-newspaper"></i>
                <span>Newspaper</span>
              </div>
            </div>
          )}
          {/* Add other additional services */}
        </div>
      </div>
    </div>
  );
};

export default FacilityTab;
